import Vue from 'vue'
import { Component, Inject } from 'vue-property-decorator'
import { Routes } from '../Routes'

@Component
export default class FullscreenWithCard extends Vue {
  @Inject() routes!: Routes
}

Vue.component('fullscreen-with-card', FullscreenWithCard)
